<template>
<div class="column is-full">
    <div v-show="!isEditing">
        <div class="card-header">
            <p class="card-header-title">{{ behaviorData.name }} ({{ displayDataType(behaviorData.dataType) }})</p>
        </div>
        <footer class="card-footer">
            <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
            <a href="#" class="card-footer-item" v-on:click="deleteData(behaviorData)">Delete</a>
        </footer>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit Item</p>
        </div>
        <div class="card-content">
            <div class="columns">
                <div class="column is-8"><input class="input is-success" type="text" placeholder="Item Name" v-model="behaviorData.name"></div>
                <div class="column is-2"><input class="input is-success" type="number" placeholder="Points, e.g.: 10" v-model="behaviorData.points" v-show="behaviorData.dataType != 3"></div>
                <div class="column is-2"><b-select id="newDataType" name="newDataType" v-model="newDataType">
                        <option value="1">Normal</option>
                        <option value="2">Attendance</option>
                        <option value="4">Parents App</option>
                        <option value="5">Subject Attendance</option>
                    </b-select></div>
            </div>
            <div class="columns">
                <div class="column is-3">
                    <b-select id="restrictAwardBy" name="restrictAwardBy" v-model="behaviorData.restrictAwardBy" v-show="behaviorData.dataType != 4">
                        <option value="1">Used by everyone</option>
                        <option value="2">Used only by class/department teachers/supervisors</option>
                        <option value="3">Used only by selected teachers/supervisors</option>
                    </b-select>
                </div>

                <div class="column is-3" v-show="(behaviorData.dataType == 1 || behaviorData.dataType == 4 || behaviorData.dataType == 5)">
                    <input class="input" type="number" placeholder="Scale Limit, e.g.: 5" v-model="behaviorData.scaleLimit">
                </div>

                <div class="column is-3">                
                    <b-select id="submissionLimitType" name="submissionLimitType" v-model="behaviorData.submissionLimitType">
                        <option value="1">Limit daily submission</option>
                        <option value="2">Limit yearly submission</option>
                        <option value="-1">DON'T Limit Submission Count</option>
                    </b-select>
                </div>

                <div class="column is-2" v-show="(behaviorData.dataType == 1 || behaviorData.dataType == 4 || behaviorData.dataType == 5) && (behaviorData.submissionLimitType > 0)">                
                    <input class="input" type="number" placeholder="E.g.: 5" v-model="behaviorData.submissionLimit">
                </div>
            </div>
                <div class="field">
                    <input class="input is-success" type="text" placeholder="Optional details about the item" v-model="behaviorData.info">
                </div>
                <div class="field" v-show="(behaviorData.dataType == 1 && behaviorData.restrictAwardBy == 1)">
                    <label class="label">Is this item mandatory for each submission?</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" v-model="behaviorData.isMandatory" value="0" checked>
                            No
                        </label>
                        <label class="radio">
                            <input type="radio" v-model="behaviorData.isMandatory" value="1">
                            Yes
                        </label>
                        <div v-show="behaviorData.isMandatory == 1" style="color: red;">
                            Take note that by selecting this item as mandatory, you will NOT BE ABLE TO do any submission unless you selected this item too.
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label">Is remarks mandatory for this item?</label>
                    <div class="control">
                        <label class="radio">
                            <input type="radio" v-model="behaviorData.isRemarksMandatory" value="0" checked>
                            No
                        </label>
                        <label class="radio">
                            <input type="radio" v-model="behaviorData.isRemarksMandatory" value="1">
                            Yes
                        </label>
                    </div>
                </div>

                <div class="field">
                    <slider-picker v-model="behaviorData.colour" />
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(behaviorData)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Slider } from 'vue-color'

export default {
    props: ['behaviorData'],
    components:{
        Multiselect,
        Loading,
        'slider-picker': Slider,
    },
    data() {
        return {
            initialSelectedColour : "",
            newDataType: 1,
            isEditing: false,
            currentLinkedTags: []
        };
    },
    created() {
        this.initialSelectedColour = this.behaviorData.colour
        this.newDataType = this.behaviorData.dataType
    },
    methods: {
        displayDataType(dataType){
            if (dataType == 1){
                return "Normal"
            }else if (dataType == 2){
                return "Attendance"
            }else if (dataType == 3){
                return "Notification"
            }else if (dataType == 4){
                return "Parent App"
            }else if (dataType == 5){
                return "Subject Attendance"
            }
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            data.initialSelectedColour = this.initialSelectedColour
            this.$emit('update-data', data,this.newDataType);
            // this.isEditing = false;
        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Super/ItemView.vue